import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { ArrowDown, ArrowUp, Sizes } from "@/components/icon/IconList";
import { styled } from "@mui/material";
import { RichTreeView } from "@mui/x-tree-view";
export const CategoryTreeView = styled(RichTreeView)(()=>({
        "&.MuiRichTreeView-root": {
            display: "flex",
            flexDirection: "column",
            gap: "16px"
        }
    }));
export const ChevronDown = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ _jsx(Icon, {
        icon: ArrowUp,
        className: className,
        size: Sizes.small,
        color: "rgba(28, 31, 46, 1)"
    });
};
export const ChevronUp = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ _jsx(Icon, {
        icon: ArrowDown,
        className: className,
        size: Sizes.small,
        color: "rgba(169, 175, 199, 1)"
    });
};
